'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createResponsiveConnect = exports.createMatchMediaConnect = undefined;

var _createMatchMediaConnect = require('./createMatchMediaConnect');

var _createMatchMediaConnect2 = _interopRequireDefault(_createMatchMediaConnect);

var _createResponsiveConnect = require('./createResponsiveConnect');

var _createResponsiveConnect2 = _interopRequireDefault(_createResponsiveConnect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createMatchMediaConnect = _createMatchMediaConnect2.default;
exports.createResponsiveConnect = _createResponsiveConnect2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/react-matchmedia-connect/lib/index.js
// module id = 1389
// module chunks = 0